import { render } from "./HeroSubPagination.vue?vue&type=template&id=5832c9f2"
import script from "./HeroSubPagination.vue?vue&type=script&lang=js"
export * from "./HeroSubPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__